import React, { useRef, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import mouseWheelZoom from "highcharts/modules/mouse-wheel-zoom";
import { CompactTagValue } from "../../CompactValue/CompactValue";
import { useSelector } from "react-redux";
mouseWheelZoom(Highcharts);

export function BarChartCo2BPCL({ countData, activeSwitches }) {
  const chartRef = useRef(null);

  const { selectBPCLUnits } = useSelector(
    (state) => state.dateSliceprocessDashboardState
  );
  const getColorForPlant = (plantId) => {
    const activeSwitch = activeSwitches.find(
      (switchObj) => switchObj.id === plantId
    );
    return activeSwitch ? activeSwitch.color : "#9B64B7"; // Default color if not found
  };

  const dataWithColors = countData.map((plant) => ({
    y: parseFloat(Math.abs(plant.value)),
    color: getColorForPlant(plant.id), // Use color based on plant ID
  }));

  const categories = countData?.map((plant) => plant.name);

  const options = {
    chart: {
      zooming: { mouseWheel: { enabled: true, type: "x" } },
      type: "column",
      height: 230,
      width: 230,
      backgroundColor: "transparent",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: categories,
      labels: {
        enabled: false,
      },

      max: 4,
    },
    scrollbar: {
      enabled: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "CUF%",
      },
    },
    series: [
      {
        name: "Utilization",
        data: dataWithColors,
      },
    ],
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
  };

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.chart.update(options);
    }
  }, [countData, activeSwitches, selectBPCLUnits]); // Re-run effect when countData or activeSwitches change

  return (
    <div
      style={{
        width: "100%",
        height: "195px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chartRef}
      />
    </div>
  );
}
